var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.component)?_c(_vm.component,_vm._b({tag:"component"},'component',Object.assign({}, _vm.params),false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }